import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Search: 'Search',
  ClearFilter: 'Clear filter',
  Filter: 'Filter',
  Number: 'Number',
  GreaterOrEqualThan: 'Greater or equal than',
  LesserOrEqualThan: 'Lesser or equal than',
});

export default messages;
